import React from 'react';
import { lighten } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import EditIcon from '@mui/icons-material/Edit';
import Button from 'components/Button';

const useStyles = makeStyles((theme) => ({
  card: {
    height: 150,
    marginBottom: theme.spacing(1),
    position: 'relative',
    overflow: 'hidden',
    background: ({ color }) => `linear-gradient(
      45deg,
      ${color} 30%,
      ${lighten(color, 0.2)} 90%
    )`,

    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
  },
  bgOverlay: {
    backgroundImage: ({ bgImage }) => `url(${bgImage})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    opacity: 0.8,
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  },
  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0,
    transition: 'all .2s ease-in-out',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 2,
  },
}));

export const Card = ({ card, color, onEdit, ...props }) => {
  const classes = useStyles({
    color,
    bgImage: card.overlay_graphic_url,
  });

  return (
    <Box className={classes.card} {...props}>
      {card.overlay_graphic_url && <div className={classes.bgOverlay} />}
      {onEdit && (
        <Box>
          <Button
            color="inherit"
            size="small"
            onClick={() => onEdit(card)}
            variant="text"
            sx={{ position: 'absolute', top: 4, right: 0 }}
          >
            <Stack alignItems="center">
              <EditIcon fontSize="small" />
              <Typography color="inherit" variant="small">
                Edit Card
              </Typography>
            </Stack>
          </Button>
        </Box>
      )}
      <Box
        sx={{
          backgroundColor: color,
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          p: 1,
          textAlign: 'center',
        }}
      >
        <Typography
          variant="h3"
          color="inherit"
          fontWeight={600}
          sx={{ zIndex: 1 }}
        >
          {card.overlay_text || card.card?.card_name}
        </Typography>
      </Box>
    </Box>
  );
};

const PreviewCards = ({ cards, color, onEdit }) => {
  return (
    <Box>
      <Grid container spacing={3} justifyContent="center" rowSpacing={8}>
        {cards.map((card) => (
          <Grid item xs={12} md={6} key={card.id}>
            <Card card={card} color={color} onEdit={onEdit} />
            <Typography color="text.secondary" variant="caption">
              {card.overlay_description}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PreviewCards;
